import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {reduxForm} from 'redux-form';
import FormattedDateTextInput from '../components/FormattedDateTextInput';
import {filterStyles} from '../shared/styles-filter';
import RaisedButton from 'material-ui/RaisedButton';
import {viewStyles} from '../shared/styles-view';

class DateSinceFilter extends Component {

    handleFilterSubmit = () => {
        this.props.onSubmitDate(this.props.filterDateSince);
    };

    isDisabled = (filterDateSince, loading) => {
        return (!filterDateSince || loading);
    };

    render() {
        const {
            filterDateSince,
            labelInput,
            labelSubmit,
            loading
        } = this.props;

        const disabled = this.isDisabled(filterDateSince, loading);

        return (
            <form>
                <div className="list-filter">
                    <span style={viewStyles.filterInline}>
                        <FormattedDateTextInput
                            formName="filterForm"
                            source="filter_date_since"
                            label={labelInput}
                            placeholder="MM/DD/YYYY"
                            maxDate={new Date()}
                            allowInputValue={false}
                            style={{...viewStyles.filterDateSelect, ...viewStyles.filterHalf}}
                        />
                    </span>
                    <RaisedButton
                        primary
                        type="button"
                        label={labelSubmit}
                        disabled={disabled}
                        onClick={this.handleFilterSubmit}
                        style={filterStyles.submitButton}
                    />
                    <hr style={filterStyles.break}/>
                </div>
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['filterForm'];
    if (form && form.values) {
        return {
            filterDateSince: form.values.filter_date_since
        }
    }
    return {
        filterDateSince: null
    }
};

DateSinceFilter.propTypes = {
    labelInput: PropTypes.string,
    labelSubmit: PropTypes.string,
    loading: PropTypes.bool,
    onSubmitDate: PropTypes.func,
};

DateSinceFilter.defaultProps = {
    labelInput: 'Select Since Date',
    labelSubmit: 'Search',
    loading: false
};

const enhance = compose(
    connect(
        mapStateToProps
    ),
    reduxForm({
        form: 'filterForm'
    })
);

export default enhance(DateSinceFilter);



// WEBPACK FOOTER //
// ./src/Fuse/components/DateSinceFilter.js